import type { Vacancy } from '@/api/generated/types.gen';

// Dev-only fake apply pages for layout edge cases. No network, no real data.
const LOGO =
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><rect width="64" height="64" rx="14" fill="#2563EB"/><path d="M14 44 L24 20 L32 36 L40 20 L50 44" fill="none" stroke="#fff" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  );

function sample(
  key: string,
  name: string,
  company: string,
  options: { logo?: boolean; theme?: string; phone?: boolean } = {},
): Vacancy {
  return {
    id: `dev-${key}`,
    public_id: `dev-${key}`,
    company_id: 'dev-company',
    name,
    company_info: {
      public_id: 'dev-company',
      name: company,
      profile_image: options.logo ? LOGO : '',
      apply_page_theme: options.theme ?? null,
    },
    mind_config: { call_feature_enabled: Boolean(options.phone) },
  } as Vacancy;
}

export const DEV_SAMPLES = {
  'long-title': sample(
    'long-title',
    'Customer Service Candidate Interview – Communication, Problem‑Solving & Values Alignment',
    'Northwind Support',
    { logo: true },
  ),
  'long-company': sample(
    'long-company',
    'Customer Service Representative',
    'Institute of Applied Engineering and Technology, Northern Campus',
  ),
  rtl: sample(
    'rtl',
    'مقابلة أولى لوظيفة خدمة العملاء، سنطرح عليك بعض الأسئلة لتقييم مهاراتك',
    'Contoso',
  ),
  georgian: sample('georgian', 'მათემატიკის ტესტი / ეროვნულები', 'Fabrikam', {
    logo: true,
    theme: 'blue',
  }),
  phone: sample('phone', 'First Interview – Accounting', 'Tailspin', {
    logo: true,
    theme: 'amber',
    phone: true,
  }),
  short: sample('short', 'Sales Rep', 'Acme'),
  'no-logo': sample('no-logo', 'Sales Advisor', 'Tesla'),
} satisfies Record<string, Vacancy>;

export type DevSampleKey = keyof typeof DEV_SAMPLES;

export const DEV_SAMPLE_LABELS: Record<DevSampleKey, string> = {
  'long-title': 'Long title + logo',
  'long-company': 'Long company, no logo',
  rtl: 'Arabic (RTL) title',
  georgian: 'Georgian, blue theme',
  phone: 'Phone field, amber',
  short: 'Short title',
  'no-logo': 'No logo (initial)',
};

export function getDevSample(key?: string): Vacancy | undefined {
  if (!import.meta.env.DEV || !key || !(key in DEV_SAMPLES)) return undefined;
  return DEV_SAMPLES[key as DevSampleKey];
}
